"use strict";

import Overlay from "ol/Overlay";
import jQuery from 'jquery';

/**
 * Control zur Darstellung eines Tooltips.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.OLMapTooltip = function(ol_map)
{
	/**
	 * @type {ol.Map}
	 * @private
	 */
	this._map = ol_map;

	/**
	 * @type {ol.Overlay|undefined}
	 * @private
	 */
	this._tooltip = undefined;

	/**
	 * @type {jQuery|undefined}
	 * @private
	 */
	this._tooltipElement = undefined;

	/**
	 * @type {boolean}
	 * @private
	 */
	this._enabled = false;

	/**
	 * @type {boolean}
	 * @private
	 */
	this._hoverMap = false;

	// Tooltip initialisieren
	this._setupTooltip();
};

/**
 * Initialisiert den Tooltip.
 *
 * @private
 */
gc.gis.OLMapTooltip.prototype._setupTooltip = function()
{
	this._tooltipElement = jQuery('<div>', {
		'class': 'gc-map-help-tooltip'
	});
	this._tooltipElement.hide();

	this._tooltip = new Overlay({
		element: this._tooltipElement[0],
		offset: [15, 0],
		positioning: 'center-left'
	});

	const createMoveHandler = function (overlay) {
		return function(evt) {
			if (evt.dragging)
			{
				return;
			}
			overlay.setPosition(evt.coordinate);
		}
	};
	const createEnterHandler = function (tooltip) {
		return function(evt) {
			tooltip._hoverMap = true;
			tooltip._update();
		};
	};
	const createOutHandler = function (tooltip) {
		return function(evt) {
			tooltip._hoverMap = false;
			tooltip._update();
		};
	};

	this._map.on('pointermove', createMoveHandler(this._tooltip), this);
	this._map.getViewport().addEventListener('mouseenter', createEnterHandler(this));
	this._map.getViewport().addEventListener('mouseout', createOutHandler(this));
};

/**
 * Blendet einen Tooltip ein.
 *
 * @param {string} text
 */
gc.gis.OLMapTooltip.prototype.show = function(text)
{
	this._tooltipElement.html(text);
	this._enabled = true;
	this._update();
};

/**
 * Blendet den Tooltip aus.
 */
gc.gis.OLMapTooltip.prototype.hide = function()
{
	// this._tooltipElement.html('');
	this._enabled = false;
	this._update();
};

/**
 * Aktualisiert den Anzeigezustand des Tooltips.
 * @private
 */
gc.gis.OLMapTooltip.prototype._update = function()
{
	if (this._enabled && this._hoverMap)
	{
		// wenn Overlay bereits eine Kartenreferenz hat, dann wurde er breits hinzugefügt
		if (!this._tooltip.getMap())
		{
			this._tooltipElement.show();
			this._map.addOverlay(this._tooltip);
		}
	}
	else
	{
		// wenn Overlay keine Kartenreferenz hat, dann wurde er noch nicht hinzugefügt
		if (this._tooltip.getMap())
		{
			this._map.removeOverlay(this._tooltip);
			this._tooltipElement.hide();
		}
	}
};